import { Footer as DSFooter } from "@globalgiving/components"
import { FC, useMemo } from "react"
import { config } from "~/config"

const navigationLinksConfigs = [
  { title: "Privacy", path: "/aboutus/privacy/" },
  { title: "Cookies", path: "/aboutus/cookies/" },
  { title: "Terms", path: "/aboutus/terms/" },
  { title: "Pricing", path: "/aboutus/fee/" },
  { title: "API", path: "/api/" },
  { title: "Data", path: "/open-data/" },
]

import FooterContactUs from "./FooterContactUs"

export const Footer: FC = () => {
  const navigationLinks = useMemo(
    () =>
      navigationLinksConfigs.map((link, index) => (
        <a
          className="text-white"
          href={config.globalGivingBaseUrl + link.path}
          key={index}
          rel="noreferrer"
          target="_blank"
        >
          {link.title}
        </a>
      )),
    []
  )

  return <DSFooter contactUs={<FooterContactUs />} navigationBar={navigationLinks} />
}
